export const PRODUCT_FRUITS_READY_LISTENER = 'productfruits_ready'
